import { FunctionComponent, PropsWithChildren } from 'react';

type PageLayoutBodyProps = PropsWithChildren;

export const PageLayoutBody: FunctionComponent<PageLayoutBodyProps> = ({ children }) => {
  return <div className="relative flex w-full flex-1 flex-grow flex-col items-stretch  px-4 pb-4">{children}</div>;
};
